import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  isReadOnly: boolean
  onAddBlock: () => void
}

export const AddBlock: React.FC<Props> = ({ isReadOnly, onAddBlock }) => (
  <div
    className={clsJoin(css.add_block, isReadOnly && css.disabled)}
    onClick={() => {
      if (isReadOnly) {
        return
      }

      onAddBlock()
    }}
  >
    <p className={css.add_block_text}>Add block...</p>
  </div>
)
